import React from "react";
import {CategoryCarouselTile} from "../categoryCarouselTile";
import {Splide, SplideSlide, SplideTrack} from "@splidejs/react-splide";
import utils from "@/libs/Utils";

const CategoryCarouselSplide = ({id, label, link, items}) => {
    const updateProgress = (splide) => {
        const end = splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((splide.index + 1) / end, 1);
        const bar = splide.root.querySelector(".splide__progress__bar");
        bar.style.width = String(100 * rate) + "%";
    };
    return (
        <Splide
            onMounted={updateProgress}
            onMove={updateProgress}
            hasTrack={false}
            options={{
                perPage: 6,
                pagination: false,
                gap: "20px",
                arrowPath:
                    "M34.661 19.181a1.156 1.156 0 0 1 0 1.637l-5.771 5.78c-1.074 1.076-2.708-.557-1.63-1.633l3.799-3.805H6.137c-1.519 0-1.519-2.313 0-2.313h24.918l-3.8-3.81c-1.073-1.075.557-2.711 1.631-1.636l5.772 5.78h.003Z",
                breakpoints: {
                    768: {
                        gap: "15px",
                        perPage: 2,
                        arrows: false,
                    },
                },
            }}
            aria-labelledby={id}
        >
            <SplideTrack>
                {items.map((item, index) => {
                    return (
                            <SplideSlide key={index}>
                                <CategoryCarouselTile
                                    link={utils.getMetaInfosValueByCode("SeoUrl", item.metaInfos)}
                                    label={item["label"]}
                                    image={utils.getMetaInfosValueByCode("Image", item.metaInfos)}/>
                            </SplideSlide>
                    );
                })}
            </SplideTrack>
            <div className="splide__progress">
                <div className="splide__progress__bar"></div>
            </div>
        </Splide>
    );
};
export default CategoryCarouselSplide;